export function Abbreviate(s:string, length:number){
    return s.slice(0,length);
}